import { render, staticRenderFns } from "./otherModule.vue?vue&type=template&id=3ff83ea8&scoped=true"
import script from "./otherModule.vue?vue&type=script&lang=js"
export * from "./otherModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff83ea8",
  null
  
)

export default component.exports